// @ts-nocheck
import React, { useCallback } from 'react';
import { FormGroup, Intent, Classes } from '@blueprintjs/core';
import classNames from 'classnames';

import { CellType } from '@/constants';
import { ContactsSearchableSuggestField } from '@/components/Contacts/ContactsSearchableSuggestField';
export default function ContactsListCellRenderer({
  column: { id },
  row: { index, original },
  cell: { value },
  payload: { contacts, updateData, errors, updateRow },
}) {
  const handleContactSelected = useCallback(
    (contact) => {
      console.log('=== CONTACT SELECTED ===');
      console.log('contact:', contact);

      // If updateRow is available, use it to update multiple fields at once
      if (updateRow) {
        if (contact) {
          // Contact selected
          console.log('contact.id:', contact.id);
          console.log('contact.contact_service:', contact.contact_service);
          updateRow(index, {
            contact_id: contact.id,
            contact_type: contact.contact_service,
            transaction_id: '',
            transaction_type: '',
          });
          console.log('Updated all fields using updateRow');
        } else {
          // Contact cleared
          console.log('Clearing contact and transaction');
          updateRow(index, {
            contact_id: null,
            contact_type: '',
            transaction_id: '',
            transaction_type: '',
          });
          console.log('Cleared contact and transaction fields');
        }
      } else {
        // Fallback: just update contact_id
        updateData(index, 'contact_id', contact ? contact.id : null);
        console.log('Updated contact_id only (updateRow not available)');
      }
    },
    [updateData, updateRow, index, id],
  );

  const error = errors?.[index]?.[id];

  return (
    <FormGroup
      intent={error ? Intent.DANGER : null}
      className={classNames(
        'form-group--select-list',
        'form-group--contacts-list',
        Classes.FILL,
      )}
    >
      <ContactsSearchableSuggestField
        onContactSelected={handleContactSelected}
        selectedContactId={original?.contact_id}
        selectedContactType={original?.contact_type}
      />
    </FormGroup>
  );
}

ContactsListCellRenderer.cellType = CellType.Field;
